import { render, staticRenderFns } from "./Ships.vue?vue&type=template&id=393d1892&scoped=true&"
import script from "./Ships.vue?vue&type=script&lang=js&"
export * from "./Ships.vue?vue&type=script&lang=js&"
import style0 from "./Ships.vue?vue&type=style&index=0&id=393d1892&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393d1892",
  null
  
)

export default component.exports